<template>
	<EbLabel :forId="uid" class="eb-radio-label" labelAfter :text="label" :required="required">
		<input :id="uid" type="radio" :value="value" @input="onInput($event.target.value)" :disabled="disabled" :required="required" :checked="checked" :name="name" />
		<span class="checkmark" />
	</EbLabel>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: null,
			required: true
		},
		value: {
			default: null,
		},
		required: {
			type: Boolean,
			default: false,
		},
		labelAfter: {
			type: Boolean,
			default: true,
		},
		checked: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: null,
			required: true
		},
		
	},
	data() {
		return {
			uid: null
		}
	},
	mounted() {
		this.uid = `uid_${this._uid}`
	},
	methods: {
		onInput(value) {
			this.$emit("input", value)
		},
	},
}
</script>

<style lang="scss" scoped>
.eb-radio-label {
	&:focus-within {
		background-color: $eb-color-blue-lighter;
		input ~ .checkmark {
			outline: $eb-border-l solid $eb-color-blue-secondary;
		}
	}
	
	input:checked ~ .checkmark {
		background-color: $eb-color-blue-secondary;
	}
	
	input:checked ~ .checkmark:after {
		display: block;
	}
	
	.checkmark {
		height: 24px;
		width: 24px;
		background-color: $white;
		border: 1px solid $eb-color-gray-600;
		border-radius: $eb-radius-circle;
		box-shadow: box-shadow-size(1);
		display: flex;
		align-items: center;
		justify-content: center;
		order: -1;
		margin-right: $eb-space-default;
		&:after {
			content: "";
			display: none;
			width: 5px;
			height: 10px;
			border: solid white;
			border-width: 0 $eb-border-m $eb-border-m 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
			top: -1px;
			position: relative;
		}
	}
	
	input[disabled] ~ .checkmark {
		background-color: $eb-color-gray-100;
		cursor: not-allowed;
	}
}
</style>
